import { memo, type ReactNode } from 'react';

import { Button, type ButtonProps } from '@air/primitive-button';

export type TaskPaneActionButtonProps = Omit<ButtonProps, 'appearance' | 'color' | 'prefix' | 'size'> & {
  icon?: ReactNode;
};

export const TaskPaneActionButton = memo(({ children, icon, type = 'button', ...rest }: TaskPaneActionButtonProps) => (
  <Button
    className="ads:text-primary text-gray-12"
    appearance="ghost"
    color="gray"
    prefix={icon}
    size="small"
    type={type}
    {...rest}
  >
    {children}
  </Button>
));

TaskPaneActionButton.displayName = 'TaskPaneActionButton';
